import { enTranslations } from './en';
import { jaTranslations } from './ja';
import { koTranslations } from './ko';

export type Language = 'en' | 'ja' | 'ko';

export const translations: Record<Language, Record<string, string>> = {
    en: enTranslations,
    ja: jaTranslations,
    ko: koTranslations,
};

export const getTranslation = (language: Language, key: string): string => {
    return translations[language]?.[key] || key;
};
